/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-no-comment-textnodes */

import dynamic from "next/dynamic";
// import ReactApexChart from "react-apexcharts";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useGetdashboardlist } from "@/hooks/useDashboard";

const ReactApexChart = dynamic(() => import("react-apexcharts"), { ssr: false });


interface dataFilter{
  alldashboardDataList:{state_city_wise_user:string[] | string | any}
  setSelectedTab :any;
  selectedTab: string;
  
}

interface  lables{
 
  _id: number;
  count: number;
  
}



const DashboardProjectActiveUser = ({alldashboardDataList, setSelectedTab, selectedTab}:dataFilter) => {
  // Define the data for the chart
 


  // Filter the data based on the selected tab ('state' or 'city')
  const filteredData =  alldashboardDataList?.state_city_wise_user;


  
  // Extract labels and values for the chart
  const labels = filteredData?.map((item:lables) => item._id);
  const values = filteredData?.map((item:lables ) => item.count);
 
  // Chart options
  const chartOptions = {
    chart: {
      toolbar: {
        show: false,
        tools: {
          zoomin: false,
          zoomout: false,
          zoom: false,
          pan: false,
          reset: false,
          //download: '<img src="/assets/images/down-arrow.svg" width="20">',
        },
      },
    },
    colors: ['#3159fe84'],
    
    xaxis: {
      categories: labels,
    },

    noData: {
      text: "No data found",
      align: "center",
      verticalAlign: "middle",
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: true,
    },
    title: {
      text: selectedTab === 'state' ? '' : '',
      align: 'right',
    },
  };

  return (
    <div style={{marginTop:"-39px"}}>
      <div className="tabs_apex" style={{textAlign: "right"}}>
        <button  onClick={() => setSelectedTab('state')} className={selectedTab === 'state' ? 'active' : ''}>State</button>
        <button  onClick={() => setSelectedTab('city')} className={selectedTab === 'city' ? 'active' : ''}>City</button>
      </div>
      <div className="chartcityCountry" style={{marginTop:"2px"}}>
      <ReactApexChart options={chartOptions} series={[{ data: values }]} type="bar" height={350} />
      </div>
    </div>
  );
};

export default DashboardProjectActiveUser;
